import { render, staticRenderFns } from "./StudentsEditMedical.vue?vue&type=template&id=7c102380&scoped=true&"
import script from "./StudentsEditMedical.vue?vue&type=script&lang=js&"
export * from "./StudentsEditMedical.vue?vue&type=script&lang=js&"
import style0 from "./StudentsEditMedical.vue?vue&type=style&index=0&id=7c102380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c102380",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCardText,VCheckbox,VCol,VRow,VTextField,VTextarea})
